<template>
  <div>
    <div
      v-if="
        notifications && notifications.list && notifications.list.length > 0
      "
    >
      <h1>Lista powiadomień admina</h1>
      <table class="table borderless  ">
        <thead>
          <tr class="tr-table">
            <th scope="col">ID</th>
            <th scope="col">typ</th>

            <th scope="col">Tytuł</th>
            <th scope="col">Wiadomość</th>
            <th scope="col">zdjęcie</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in notifications.list" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.type }}</td>

            <td>{{ item.title }}</td>
            <td>{{ item.body }}</td>
            <td>{{ item.file_id }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="alert alert-danger notFoundListAlert">
      Brak powiadomień
    </div>
  </div>
</template>

<script>
export default {
  name: "notifications-list",
  computed: {
    notifications() {
      return this.$store.getters.getNotifications;
    },
  },
  created() {
    this.$store.dispatch("getAllNotifications");
  },
  data: function() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
div.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
div.input-container {
  flex-direction: column;
  display: flex;
  margin-top: 10px;
}
button.btn {
  margin-top: 20px;
}
.topform {
  display: flex;
  flex-direction: column;
}
</style>
